import React, { useState, useRef } from 'react';
import Card from "../components/Card";
import AjaxDynamicDataTable from '@langleyfoxall/react-dynamic-data-table/dist/AjaxDynamicDataTable';
import LoadingIndicator from "../components/datatable/LoadingIndicator";
import EmptyTable from "../components/datatable/EmptyTable";
import {toast} from "react-toastify";
import {INSTALLATION_PAGES} from "../pages/JobOrderInstallationPage";
import ArchiveInstallationModal from "../modals/ArchiveInstallationModel";

const JobOrderInstallationDataTable = (props) => {
    const {
        jobId,
        orderId,
        parentId,
        onChangePage    = (CREATE, installation) => {}
    } = props;

    const dataTableRef = useRef(null);

    const [archiveInstallationModal, setArchiveInstallationModal] = useState(null);

    const renderRowButton = (installation) => {
        return (
            <td>
                <div className={"d-flex justify-content-end align-content-center align-items-center"}>
                    {!!installation.can && (installation.can.view === true || can('create', 'installation') || installation.can.update === true || installation.can.delete === true) && (
                        <div className="dropdown">
                            <button
                                className="dropdown-toggle cursor-pointer text-eh-off-black h3"
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                            >
                                <i className="far fa-ellipsis-h"/>
                            </button>
                            <div
                                className="dropdown-menu dropdown-menu-right p-0"
                                aria-labelledby="navbarDropdown"
                            >
                                {!!installation.can.view === true && (
                                    <button className={"dropdown-item cursor-pointer"}
                                            onClick={() => onChangePage(INSTALLATION_PAGES.SHOW, installation)}
                                    >
                                        <span>View Installation</span>
                                    </button>
                                )}
                                {!!installation.can.update === true && (
                                    <button className={"dropdown-item cursor-pointer"}
                                            onClick={() => onChangePage(INSTALLATION_PAGES.EDIT, installation)}
                                    >
                                        <span>Edit Installation</span>
                                    </button>
                                )}
                                {!!installation.can.delete === true && (
                                    <button className={"dropdown-item cursor-pointer"}
                                            onClick={() => setArchiveInstallationModal(installation)}
                                    >
                                        <span>Delete Installation</span>
                                    </button>
                                )}
                            </div>
                        </div>
                    )}
                </div>
            </td>
        )
    }

    return (
        <React.Fragment>
            <Card
                title={"Installations"}
                classes={"mh-100 border-0"}
                controls={can('create', 'installation') ? (
                    <button onClick={(event) => {
                        event.preventDefault();
                        onChangePage(INSTALLATION_PAGES.CREATE, null);
                    }} className={"btn font-weight-bold btn-eh-lilac px-4 m-0"}>
                        <i className={"far fa-plus-circle mr-2"} />
                        <span>{"Create Installation"}</span>
                    </button>
                ) : null}
            >
                <div className={"row m-0 p-0"}>
                    <div className={"col-12 m-0 p-0"}>
                        <div className="data-table">
                            <AjaxDynamicDataTable
                                apiUrl={route('web-api.job.order.installation.data-table', {job: jobId, order: orderId}).toString()}
                                loadingComponent={<LoadingIndicator />}
                                noDataComponent={<EmptyTable itemName="installations" />}
                                fieldsToExclude={[
                                    'created_at',
                                    'deleted_at',
                                    'can',
                                ]}
                                alwaysShowPagination
                                fieldOrder={[
                                    'id',
                                    'products_count',
                                    'status',
                                    'start_at',
                                    'end_at',
                                    'users',
                                ]}
                                fieldMap={{
                                    id:             "Installation Ref",
                                    products_count: "Products",
                                    start_at:       "Start Date",
                                    end_at:         "End Date",
                                    users:          "Installer",
                                }}
                                ref={dataTableRef}
                                defaultOrderByField={'id'}
                                defaultOrderByDirection={'asc'}
                                buttons={(row) => renderRowButton(row)}
                                dataItemManipulator={(field, value, row) => {
                                    switch (field) {
                                        case 'status':
                                            return (
                                                <span className={"text-eh-light-blue font-weight-bold"}>{value}</span>
                                            );
                                    }

                                    return <span>{value}</span>;
                                }}
                            />
                        </div>
                    </div>
                </div>
            </Card>
            <ArchiveInstallationModal
                show={!!archiveInstallationModal}
                jobId={jobId}
                orderId={orderId}
                installationId={!!archiveInstallationModal ? archiveInstallationModal.id : null}
                parentId={parentId}
                onCancel={() => setArchiveInstallationModal(null)}
                onComplete={(installation) => {
                    setArchiveInstallationModal(null)
                    dataTableRef.current.reload();
                    toast.success(<div>Installation deleted.</div>);
                }}
            />
        </React.Fragment>
    );
}

export default JobOrderInstallationDataTable;
